import { render, staticRenderFns } from "./DeviceActivationForm.vue?vue&type=template&id=28b3821d&scoped=true&"
import script from "./DeviceActivationForm.vue?vue&type=script&lang=ts&"
export * from "./DeviceActivationForm.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceActivationForm.vue?vue&type=style&index=0&id=28b3821d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b3821d",
  null
  
)

export default component.exports